import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../ServicePage.css';

function Odoo() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Odoo ERP</h1>
                    <p className="service-description">
                        Sviluppo, personalizzazione e gestione di Odoo, il sistema ERP open source
                        più versatile e completo per la gestione aziendale.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Cosa è Odoo?</h2>
                                <p className="section-description">
                                    Odoo è una suite completa di applicazioni di gestione aziendale open source che 
                                    include CRM, e-commerce, fatturazione, contabilità, produzione, magazzino, 
                                    gestione progetti e molto altro. Con oltre 15.000 app disponibili, Odoo offre 
                                    una soluzione integrata per tutte le esigenze aziendali.
                                </p>
                                
                                <div className="odoo-features">
                                    <Row>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-users text-primary"></i>
                                                <strong>CRM e Vendite</strong>
                                                <p>Gestione completa di lead, opportunità e processi di vendita</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-shopping-cart text-primary"></i>
                                                <strong>E-commerce</strong>
                                                <p>Negozio online integrato con gestione prodotti e ordini</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-file-invoice text-primary"></i>
                                                <strong>Fatturazione</strong>
                                                <p>Creazione automatica di preventivi, fatture e documenti fiscali</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-warehouse text-primary"></i>
                                                <strong>Magazzino</strong>
                                                <p>Gestione avanzata di inventario, ordini e movimenti di magazzino</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">I Nostri Servizi Odoo</h2>
                                
                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-code text-primary"></i>
                                            </div>
                                            <h4>Sviluppo Moduli Personalizzati</h4>
                                            <p>
                                                Creiamo moduli su misura per le esigenze specifiche della tua azienda,
                                                estendendo le funzionalità di Odoo con soluzioni completamente personalizzate.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-cogs text-primary"></i>
                                            </div>
                                            <h4>Gestione e Amministrazione</h4>
                                            <p>
                                                Offriamo servizi completi di gestione Odoo: installazione, configurazione,
                                                aggiornamenti, backup e manutenzione del sistema.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-link text-primary"></i>
                                            </div>
                                            <h4>Integrazione con E-commerce</h4>
                                            <p>
                                                Specializzati nell'integrazione di Odoo con piattaforme e-commerce come 
                                                <strong> Magento</strong>, WooCommerce e altri sistemi di vendita online.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-exchange-alt text-primary"></i>
                                            </div>
                                            <h4>Migrazione e Integrazione</h4>
                                            <p>
                                                Migrazione da altri sistemi ERP a Odoo e integrazione con software 
                                                esistenti per creare un ecosistema aziendale completo.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/*
                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card reseller-card">
                            <Card.Body>
                                <div className="reseller-badge">Coming Soon</div>
                                <h2 className="section-title">Rivendita Odoo tramite SwebSolution</h2>
                                <p className="section-description">
                                    Oltre allo sviluppo e alla personalizzazione, siamo rivenditori autorizzati Odoo
                                    attraverso la nostra piattaforma dedicata <strong>SwebSolution</strong>.
                                    Ti accompagniamo nella scelta delle licenze, nell'attivazione dei moduli
                                    e nella gestione degli abbonamenti, con un unico referente per tutto il ciclo di vita del tuo ERP.
                                </p>
                                <p className="section-description mb-0">
                                    La piattaforma <strong>swebsolution.it</strong> è in fase di lancio.
                                    Per informazioni anticipate sulle licenze e sui pacchetti disponibili,
                                    contattaci direttamente.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                */}

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Perché Scegliere i Nostri Servizi Odoo?</h2>
                                
                                <Row>
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-certificate text-primary"></i>
                                            </div>
                                            <h5>Esperienza Certificata</h5>
                                            <p>Anni di esperienza nello sviluppo e nell'implementazione di soluzioni Odoo</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-puzzle-piece text-primary"></i>
                                            </div>
                                            <h5>Soluzioni Su Misura</h5>
                                            <p>Ogni implementazione è personalizzata per le specifiche esigenze aziendali</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-headset text-primary"></i>
                                            </div>
                                            <h5>Supporto Continuo</h5>
                                            <p>Assistenza tecnica dedicata e formazione del personale</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card className="service-card cta-card">
                            <Card.Body className="text-center">
                                <h3>Pronto a Trasformare la Tua Gestione Aziendale?</h3>
                                <p className="mb-4">
                                    Contattaci per una consulenza gratuita e scopri come Odoo può 
                                    migliorare l'efficienza della tua azienda.
                                </p>
                                <a href="#contact" className="btn btn-primary btn-lg">
                                    Richiedi Consulenza Gratuita
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Odoo;